module.exports = __webpack_public_path__ + "static/media/LogoMain.dde6fcbd.png";